import VariationChangedEvent from '../VariationChangedEvent';
import type { QBus } from '@otto-ec/global-resources/event-q-bus';
import { serviceLogger } from '../Logger';
import { DetailviewClient } from './DetailviewClient';

const log = serviceLogger.scope('detail-view-service');

const variationChangedTopic = 'ft9.up-teaser.variationChanged';

export class DetailviewService {
	private eventBus: QBus;

	private receivedVariationChangedEvent;

	private detailviewClient: DetailviewClient;

	private handleVariationChange;

	constructor(eventBus: QBus, detailviewClient: DetailviewClient) {
		this.eventBus = eventBus;
		this.detailviewClient = detailviewClient;
	}

	/*                       */
	registerEventListener(): Promise<any[]> {
		this.handleVariationChange = this.onVariationChanged.bind(this);

		return Promise.all([
			this.eventBus.on(variationChangedTopic, this.handleVariationChange)
		]);
	}

	onTeaserUIReady() {
		this.eventBus.emit(variationChangedTopic, this.receivedVariationChangedEvent);
	};

	onVariationChanged(event: VariationChangedEvent) {
		this.detailviewClient.getFromTeaserUI().then((htmlContent) => {
			this.receivedVariationChangedEvent = event;
			this.eventBus.off(variationChangedTopic, this.handleVariationChange);
			this.eventBus.on('ft9bcn.teaserui.teaser.isReady', this.onTeaserUIReady.bind(this));
			this.handleHTMLContentInTargetElementParent(event.targetElement, htmlContent);
		}).catch((reason) => {
			log.error(reason);
		});
	}

	executeScriptElements(containerElement: HTMLElement) {
		const scriptElements = containerElement.querySelectorAll('script');

		Array.from(scriptElements).forEach((scriptElement: HTMLScriptElement) => {
			const clonedElement = document.createElement('script');

			Array.from(scriptElement.attributes).forEach((attribute) => {
				clonedElement.setAttribute(attribute.name, attribute.value);
			});

			clonedElement.text = scriptElement.text;

			scriptElement.parentNode?.replaceChild(clonedElement, scriptElement);
		});
	}

	private handleHTMLContentInTargetElementParent(targetElement: HTMLElement, htmlContent: string) {
		const elementToHoldScripts = document.createElement('div');
		elementToHoldScripts.innerHTML = htmlContent;
		targetElement.parentElement?.insertAdjacentElement('beforeend', elementToHoldScripts);
		this.executeScriptElements(elementToHoldScripts);
	}
}
